
import { Component, Prop, Vue } from 'vue-property-decorator'
import { HoverableIcon, HoverableIconBig, IconDataSpan } from 'ui-library'
import { navigate } from '@/utils/NavigationUtils'

@Component({
  components: { HoverableIcon, HoverableIconBig }
})
export default class IconBox extends Vue {
  @Prop({ required: true })
  private iconDataList!: IconDataSpan[]

  private onClick(href: string): void {
    navigate(href)
  }
}
